import dynamic from 'next/dynamic';
import type { FunctionComponent } from 'react';

import { isB2B } from '@/domains/core/settings/utils';
import type { MobileAppsProps } from '@/domains/retention/Footer/modules/MobileApps/MobileApps';
import { Payment } from '@/domains/retention/Footer/modules/Quality/components/Payment/Payment';
import { SocialMedia } from '@/domains/retention/Footer/modules/SocialMedia/SocialMedia';
import { Support } from '@/domains/retention/Footer/modules/Support/Support';

const DynamicMobileApps = dynamic<MobileAppsProps>(() =>
  import('@/domains/retention/Footer/modules/MobileApps/MobileApps').then(
    (mod) => mod.MobileApps,
  ),
);

export const RightColumn: FunctionComponent = () => (
  <>
    <DynamicMobileApps />
    <Payment />
    {isB2B() && <Support className="hidden desktop:hidden" />}
    <SocialMedia />
  </>
);

RightColumn.displayName = 'RightColumn';
